<div class="container">
  <h1>
    {{ 'journal.statistiqueConnexion.titrePage' | translate }}
  </h1>

  <div class="form-container">
    <form [formGroup]="form"
      (ngSubmit)="rechercher()">
      <div class="inputs-container">
        <!-- Date de début -->
        <mat-form-field appearance="fill">
          <mat-label>{{ 'journal.statistiqueConnexion.form.dateDebut' | translate }}</mat-label>
          <input matInput
            [matDatepicker]="dateDebut"
            formControlName="dateDebut"
            placeholder="Choisir une date"
            [required]="form.errors?.requiredAtLeastOne">
          <mat-datepicker-toggle matSuffix
            [for]="dateDebut"></mat-datepicker-toggle>
          <mat-datepicker #dateDebut></mat-datepicker>
        </mat-form-field>

        <!-- Date de fin -->
        <mat-form-field appearance="fill">
          <mat-label>{{ 'journal.statistiqueConnexion.form.dateFin' | translate }}</mat-label>
          <input matInput
            [matDatepicker]="dateFin"
            formControlName="dateFin"
            placeholder="Choisir une date">
          <mat-datepicker-toggle matSuffix
            [for]="dateFin"></mat-datepicker-toggle>
          <mat-datepicker #dateFin></mat-datepicker>
        </mat-form-field>

        <!-- Type Utilisateur -->
        <mat-form-field appearance="fill">
          <mat-label>{{ 'journal.statistiqueConnexion.form.typeUtilisateur' | translate }}</mat-label>
          <mat-select formControlName="type"
            [required]="form.errors?.requiredAtLeastOne">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let typeutilis of listeTypeUtilisateur"
              [value]=typeutilis.valeur>
              {{typeutilis.description}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="!form.pristine && form.touched">
        <div class="invalid-feedback"
          *ngFor="let entry of form.errors | keyvalue">
          {{entry.value.message}}
        </div>
      </div>

      <!-- Boutons -->
      <div class="buttons-container">
        <button mat-raised-button
          color="secondary"
          type="button"
          class="me-2"
          (click)="reinitialiser()">
          {{ 'sigt.global.boutons.reinitialiser' | translate }}
        </button>

        <button mat-raised-button
          color="primary"
          type="submit"
          [disabled]="!form.valid">
          {{ 'sigt.global.boutons.rechercher' | translate }}
        </button>
      </div>
    </form>
  </div>

  <div class="table-container mb-3">
    <table mat-table
      [dataSource]="dataSource"
      (matSortChange)="trier($event)"
      matSort
      class="mat-elevation-z8">
      <!-- Code -->
      <ng-container matColumnDef="codeUtilisateur">
        <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header="codeUtilisateur">{{ 'journal.statistiqueConnexion.grille.code' | translate }}</th>
        <td mat-cell
          *matCellDef="let element"> {{ element.codeUtilisateur }} </td>
      </ng-container>

      <!-- Nom Prenom -->
      <ng-container matColumnDef="nomPrenom">
        <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header="nomPrenom">{{ 'journal.statistiqueConnexion.grille.nom' | translate }}</th>
        <td mat-cell
          *matCellDef="let element"> {{ element.nomPrenom }} </td>
      </ng-container>

      <!-- Type -->
      <ng-container matColumnDef="type">
        <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header="type">{{ 'journal.statistiqueConnexion.grille.typeutilisateur' | translate }}</th>
        <td mat-cell
          *matCellDef="let element"> {{ element.type }} </td>
      </ng-container>

      <!-- Employeur -->
      <ng-container matColumnDef="nomDirectionOuEmployeur">
        <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header="nomDirectionOuEmployeur">{{ 'journal.statistiqueConnexion.grille.nomdirectionemployeur' |
          translate }}</th>
        <td mat-cell
          *matCellDef="let element"> {{ element.nomDirectionOuEmployeur }} </td>
      </ng-container>

      <!-- Acces -->
      <ng-container matColumnDef="nombreAcces">
        <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header="nombreAcces">{{ 'journal.statistiqueConnexion.grille.totalnombreacces' | translate }}</th>
        <td mat-cell
          *matCellDef="let element"> {{ element.nombreAcces }} </td>
      </ng-container>

      <tr mat-header-row
        *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row
        *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <div *ngIf="dataSource.data && dataSource.data.length === 0"
    class="no-data-message mb-3">
    {{ 'sigt.global.messageAucuneDonnee' | translate }}
  </div>

  <mat-paginator [pageSizeOptions]="[25, 50, 100, 1000]"
    [pageSize]="25"
    [length]="tableState.pageLength"
    (page)="changerPage($event)"
    showFirstLastButtons></mat-paginator>
</div>